import { h, Component } from "preact";
import Api, { FullWork } from "../../api";
export interface StatsProps { }
interface StatsState {
   stats: string;
}
export class StatsComponent extends Component<StatsProps, StatsState> {
   constructor(props: StatsProps) {
      super(props);
   }

   async componentWillMount() {
      let stats = "";
      let works = await Api.getWorks()
      stats += "Works: " + works.length.toString() + "<br>";
      let tag_cnt: { tag: string, count: number }[] = [];
      let type_cnts = {};
      let words = 0;
      works.forEach(e => {
         words += e.words;
         if (!type_cnts[e.type])
            type_cnts[e.type] = 0;
         type_cnts[e.type]++;
         e.tags.forEach(t => {
            let tc = tag_cnt.find(c => c.tag === t);
            if (tc) tc.count++;
            else tag_cnt.push({ tag: t, count: 1 });
         })
      })
      console.log(type_cnts);
      tag_cnt = tag_cnt.sort((e1, e2) => e2.count - e1.count);
      stats += "Words: " + words.toString() + "<br>";
      stats += `- Wattpad : ${type_cnts["wattpad"] || 0}<br>`;
      stats += `- AO3     : ${type_cnts["ao3"] || 0}<br>`;
      stats += `- Epub    : ${type_cnts["epub"] || 0}<br>`;
      stats += `- Manually: ${type_cnts["manually"] || 0}<br>`;
      stats += "Most favourite tags: <br>";
      for (let i = 0; i < 10 && i < tag_cnt.length; i++) {
         stats += `- ${tag_cnt[i].tag}: ${tag_cnt[i].count} <br>`
      }
      stats += `${tag_cnt.length} different tags`;
      this.setState({ stats });
   }

   //style="background-color: {{theme.background}}; color: {{theme.color}}; font-size: {{font_size}}"
   render(props: StatsProps, state: StatsState) {
      return <div style="background: var(--background)" >
         <div class="container">
            <div class="row">
               <div class="col col-12 col-sm-12 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2 col-xl-6 col-xl-offset-3" ref={elm => elm ? elm.innerHTML = state.stats || "" : undefined}>
               </div>
            </div>
         </div>
      </div>
   }
}